import type { RegisterBuxusRequest } from "@buxus/shared";
import { parseAccountSetupCrmResponse } from "@buxus/shared";
import {
  REGISTRATION_ACCOUNT_SETUP_CRM_URL,
  REGISTRATION_FIND_USER_BY_EMAIL_URL,
  REGISTRATION_QUICK_CODE_LOOKUP_URL,
  REGISTRATION_REGISTER_BUXUS_URL,
  REGISTRATION_SEND_RESPONDER_INVITES_URL,
  REGISTRATION_TENANT_ID,
} from "../platform/abp/config";
import { httpJson } from "../platform/abp/httpClient";

export { parseAccountSetupCrmResponse };

/** POST /api/user/find-by-email-in-buxus — CheckUserExistsDto (verify.buxus.io). */
export type CheckUserExistsDto = {
  emailAddress?: string | null;
  zohoId?: string | null;
  zohoCrmId?: string | null;
  userId?: string | null;
};

type RegisterBuxusResponse = {
  canLogin?: boolean;
  userId?: string;
};

export async function getContactByQuickCodeComputed(quickCode: string): Promise<unknown> {
  return httpJson<unknown>(REGISTRATION_QUICK_CODE_LOOKUP_URL, {
    method: "POST",
    headers: { "Abp.TenantId": REGISTRATION_TENANT_ID },
    body: { quickCode: quickCode.trim() },
  });
}

export async function findUserByEmailInBuxus(emailAddress: string): Promise<CheckUserExistsDto | null> {
  return httpJson<CheckUserExistsDto | null>(REGISTRATION_FIND_USER_BY_EMAIL_URL, {
    method: "POST",
    headers: { "Abp.TenantId": REGISTRATION_TENANT_ID },
    body: { emailAddress },
  });
}

export async function registerBuxusAccount(input: RegisterBuxusRequest): Promise<RegisterBuxusResponse> {
  return httpJson<RegisterBuxusResponse>(REGISTRATION_REGISTER_BUXUS_URL, {
    method: "POST",
    headers: { "Abp.TenantId": REGISTRATION_TENANT_ID },
    body: input,
  });
}

export async function accountSetupCrm(body: Record<string, unknown>): Promise<unknown> {
  return httpJson<unknown>(REGISTRATION_ACCOUNT_SETUP_CRM_URL, {
    method: "POST",
    headers: { "Abp.TenantId": REGISTRATION_TENANT_ID },
    body,
  });
}

export type SendResponderInvitesResult = {
  jobId?: string;
  success?: boolean;
};

/** POST /api/buxus/send-responder-invites — commander invites colleagues by email. */
export async function sendResponderInvites(input: {
  emails: string[];
  commanderId?: string | null;
}): Promise<SendResponderInvitesResult> {
  const raw = await httpJson<Record<string, unknown>>(REGISTRATION_SEND_RESPONDER_INVITES_URL, {
    method: "POST",
    headers: { "Abp.TenantId": REGISTRATION_TENANT_ID },
    body: {
      emails: input.emails,
      commanderId: input.commanderId?.trim() || undefined,
    },
  });
  return {
    jobId: (raw.jobId ?? raw.JobId) as string | undefined,
    success: (raw.success ?? raw.Success) as boolean | undefined,
  };
}
